import { createAuthClient } from '../common/auth-client.mjs'
export { ApiError } from '../common/auth-client.mjs'
export const createUserAuthClient = options => createAuthClient({ ...options, area: 'user' })
